export default __webpack_public_path__ + "static/media/graph-g.b290414b.svg";